import React from 'react';
import Layout from '../components/layout/Layout';
import Button from '../components/common/Button';
import {
  FiTrendingUp,
  FiTarget,
  FiUsers,
  FiBarChart2
} from 'react-icons/fi';

const AdvertisePage = () => {
  return (
    <Layout title="Advertise Now">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="bg-gradient-to-br from-primary-500 to-primary-700 rounded-card shadow-card p-12 text-white text-center mb-8">
          <FiTrendingUp className="w-16 h-16 mx-auto mb-4" />
          <h1 className="text-3xl font-bold mb-4">Advertise Your Business</h1>
          <p className="text-lg opacity-90 max-w-2xl mx-auto">
            Promote your store to reach more customers in your area. Get featured in search results and customer dashboards.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          <div className="bg-white rounded-card shadow-card p-6">
            <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center mb-4">
              <FiTarget className="w-6 h-6 text-primary-600" />
            </div>
            <h3 className="text-lg font-semibold text-neutral-900 mb-2">Targeted Reach</h3>
            <p className="text-sm text-neutral-600">
              Your ads will be shown to customers in your specific area and category
            </p>
          </div>

          <div className="bg-white rounded-card shadow-card p-6">
            <div className="w-12 h-12 bg-success-100 rounded-full flex items-center justify-center mb-4">
              <FiUsers className="w-6 h-6 text-success-600" />
            </div>
            <h3 className="text-lg font-semibold text-neutral-900 mb-2">Increase Visibility</h3>
            <p className="text-sm text-neutral-600">
              Get featured prominently in customer searches and nearby store listings
            </p>
          </div>

          <div className="bg-white rounded-card shadow-card p-6">
            <div className="w-12 h-12 bg-warning-100 rounded-full flex items-center justify-center mb-4">
              <FiBarChart2 className="w-6 h-6 text-warning-600" />
            </div>
            <h3 className="text-lg font-semibold text-neutral-900 mb-2">Track Performance</h3>
            <p className="text-sm text-neutral-600">
              Monitor ad impressions, clicks, and customer engagement metrics
            </p>
          </div>
        </div>

        {/* Pricing Tiers */}
        <div className="bg-white rounded-card shadow-card p-8 mb-8">
          <h2 className="text-2xl font-bold text-neutral-900 mb-6 text-center">Advertisement Packages</h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Basic Package */}
            <div className="border-2 border-neutral-200 rounded-card p-6 hover:border-primary-500 transition-colors">
              <h3 className="text-lg font-semibold text-neutral-900 mb-2">Basic</h3>
              <div className="text-3xl font-bold text-primary-600 mb-4">
                BHD 5<span className="text-sm font-normal text-neutral-600">/month</span>
              </div>
              <ul className="space-y-2 text-sm text-neutral-600 mb-6">
                <li>Featured in search results</li>
                <li>Basic analytics</li>
                <li>1 promotional offer</li>
                <li>Email support</li>
              </ul>
              <Button variant="outline" className="w-full">
                Select Basic
              </Button>
            </div>

            {/* Pro Package */}
            <div className="border-2 border-primary-500 rounded-card p-6 relative bg-primary-50">
              <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-primary-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
                POPULAR
              </div>
              <h3 className="text-lg font-semibold text-neutral-900 mb-2">Pro</h3>
              <div className="text-3xl font-bold text-primary-600 mb-4">
                BHD 15<span className="text-sm font-normal text-neutral-600">/month</span>
              </div>
              <ul className="space-y-2 text-sm text-neutral-600 mb-6">
                <li>Priority placement</li>
                <li>Advanced analytics</li>
                <li>Unlimited offers</li>
                <li>Featured badge</li>
                <li>Priority support</li>
              </ul>
              <Button className="w-full">
                Select Pro
              </Button>
            </div>

            {/* Premium Package */}
            <div className="border-2 border-neutral-200 rounded-card p-6 hover:border-primary-500 transition-colors">
              <h3 className="text-lg font-semibold text-neutral-900 mb-2">Premium</h3>
              <div className="text-3xl font-bold text-primary-600 mb-4">
                BHD 30<span className="text-sm font-normal text-neutral-600">/month</span>
              </div>
              <ul className="space-y-2 text-sm text-neutral-600 mb-6">
                <li>Top listing priority</li>
                <li>Full analytics dashboard</li>
                <li>Unlimited offers</li>
                <li>Social media promotion</li>
                <li>Dedicated account manager</li>
              </ul>
              <Button variant="outline" className="w-full">
                Select Premium
              </Button>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="bg-neutral-50 rounded-card p-8 text-center">
          <h3 className="text-xl font-bold text-neutral-900 mb-4">Ready to Get Started?</h3>
          <p className="text-neutral-600 mb-6 max-w-2xl mx-auto">
            This feature is currently in development. Contact our team to learn more about early access and special launch pricing.
          </p>
          <div className="flex gap-4 justify-center">
            <Button>
              Contact Sales
            </Button>
            <Button variant="outline">
              Learn More
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AdvertisePage;
